import script from "./TaskDetailDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskDetailDialog.vue?vue&type=script&setup=true&lang=js"

import "./TaskDetailDialog.vue?vue&type=style&index=0&id=2bcd4e75&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bcd4e75"]])

export default __exports__